module.exports = __webpack_public_path__ + "images/buttons/sign_up_big.png";